import { useCallback, useEffect } from 'react';
import { type ListBoxItem, Select } from '@direct-frontend/components';
import { noop } from '@direct-frontend/stdlib';
import { type OpenApiSchemaCardSortOrder } from '#shared/api/schema';
import { showError } from '#shared/lib/toast';
import { useGetProductsCardSortOrderSettings, usePatchProductsCardSortOrderSettings } from '../../api';

const items: ListBoxItem<OpenApiSchemaCardSortOrder, OpenApiSchemaCardSortOrder>[] = [
    {
        value: 'PRICE_CHARACTERISTIC',
        content: 'Сначала по цене, потом по группирующим характеристикам',
    },
    {
        value: 'CHARACTERISTIC_PRICE',
        content: 'Сначала по группирующим характеристикам, потом по цене',
    },
];

export const ProductsCardSortSelect = () => {
    const { data, isError } = useGetProductsCardSortOrderSettings();

    const [patchProductsCardSortOrderSettings, { isLoading, isError: isErrorPatch }] =
        usePatchProductsCardSortOrderSettings();

    const handleChange = useCallback(
        async (value: OpenApiSchemaCardSortOrder) => {
            if (data?.card_sort_order === value) {
                return;
            }

            await patchProductsCardSortOrderSettings({ card_sort_order: value });
        },
        [patchProductsCardSortOrderSettings, data?.card_sort_order]
    );

    useEffect(() => {
        if (isErrorPatch) {
            showError({ label: 'Ошибка изменения сортировки' });
        }
    }, [isErrorPatch]);

    if (isError || !data) {
        return (
            <Select
                items={[
                    {
                        value: 'error',
                        content: 'Ошибка загрузки',
                    },
                ]}
                value="error"
                isDisabled
                color="contour"
                size="s"
                width="max"
                onChange={noop}
            />
        );
    }

    return (
        <Select<OpenApiSchemaCardSortOrder>
            items={items}
            color="contour"
            size="s"
            width="max"
            value={data.card_sort_order}
            isLoading={isLoading}
            isDisabled={isLoading}
            onChange={handleChange}
        />
    );
};
